import React from 'react';

const Grid = ({
  guesses,
  currentGuess,
  currentRow,
  solution,
  isTypingEnabled = true,
}) => {
  const getLetterStatus = (letter, index, row) => {
    if (!letter) return '';
    // Convert solution to uppercase for consistent comparisons.
    const upperSolution = solution.toUpperCase();
    
    // Only compute status if the guess exists
    if (guesses[row] !== '') {
      // Build a map of letters in the solution that were NOT matched correctly.
      const remainingLetters = {};
      [...upperSolution].forEach((l, i) => {
        if (guesses[row][i] !== l) {
          remainingLetters[l] = (remainingLetters[l] || 0) + 1;
        }
      });

      let status = '';
      
      // Check for correct position first.
      if (upperSolution[index] === letter) {
        status = 'correct';
      }
      // If not correct, check if the letter exists elsewhere.
      else if (remainingLetters[letter] > 0) {
        // Count how many of this letter have already been considered (and weren't correct).
        const lettersBefore = [...guesses[row]]
          .slice(0, index)
          .filter((l, i) => l === letter && upperSolution[i] !== l).length;
        
        if (lettersBefore < remainingLetters[letter]) {
          remainingLetters[letter]--;
          status = 'present';
        } else {
          status = 'absent';
        }
      } else {
        status = 'absent';
      }
      
      // Return the status with an animation class.
      return `${status} flip`;
    }
    return '';
  };

  return (
    <div className="grid">
      {guesses.map((guess, i) => (
        <div key={i} className="row">
          {Array(5)
            .fill(null)
            .map((_, j) => {
              let letter = guess[j];
              // Only show in-progress typing on the active row when that row does not
              // already contain a committed guess. This keeps the final submitted row
              // visible (and colorized) on win/loss screens.
              if (i === currentRow && !guess) {
                letter = currentGuess[j];
              }
              const showCaret =
                isTypingEnabled &&
                i === currentRow &&
                currentGuess.length < 5 &&
                j === currentGuess.length &&
                !letter;
              return (
                <div 
                  key={j} 
                  className={`cell ${getLetterStatus(letter, j, i)}`}
                >
                  {letter || (showCaret ? '_' : '')}
                </div>
              );
            })}
        </div>
      ))}
    </div>
  );
};

export default Grid;
